var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHandouts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 87,
    viewBox: "0 0 130 87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-handouts_svg__a",
    width: "145.3%",
    height: "139.3%",
    x: "-22.6%",
    y: "-19.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.261090472 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "icon-handouts_svg__b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.540053 0 0 0 0 0.160741 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D3528D",
    d: "M94.753 40.494c5.775 15.687-3.523 32.402-17.388 38.139-11.91 4.926-29.448 6.707-45.958-11.592-13.631-15.108-14.256-31.695-4.08-40.152 20.41-16.964 58.54-10.53 67.426 13.605z",
    opacity: 0.799
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-handouts_svg__a)",
    transform: "translate(39 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAC0B7",
    d: "M0 0v60.891h39.332V48.014H52.26V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.332 48.015V60.89L52.26 48.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE836E",
    d: "M5.451 13.373h41.36v-2.581H5.451zM5.45 18.3h36.828v-2.581H5.45zm0-9.854h10.6V5.865H5.45z",
    opacity: 0.548
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1705F",
    d: "M7.754 45.163h14.61v-2.932H7.754zm23.218 0H45.58v-2.932H30.972z",
    opacity: 0.805
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-handouts_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#762C11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.404 29.186a2.34 2.34 0 01-2.345 2.336 2.34 2.34 0 01-2.345-2.336 2.34 2.34 0 012.345-2.335 2.34 2.34 0 012.345 2.335z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.803 37.668v-2.09a2.347 2.347 0 012.345-2.336h1.822a2.347 2.347 0 012.345 2.336v2.09"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M22.565 31.097c0 4.129-3.361 7.476-7.506 7.476-4.146 0-7.505-3.347-7.505-7.476 0-4.13 3.36-7.477 7.505-7.477s7.506 3.347 7.506 7.477z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M43.138 38.72h-9.724c-.863 0-1.57-.704-1.57-1.563v-7.74c0-.86.707-1.563 1.57-1.563h9.724c.862 0 1.569.703 1.569 1.563v7.74c0 .86-.707 1.563-1.569 1.563zm-7.711-10.946v-1.618a2.696 2.696 0 012.694-2.684h.31a2.696 2.696 0 012.693 2.684v1.618h-5.697z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M39.739 32.436c0 .79-.644 1.43-1.436 1.43-.795 0-1.438-.64-1.438-1.43 0-.79.643-1.43 1.438-1.43.792 0 1.436.64 1.436 1.43zm-1.461 4.039v-2.346"
  })))))));
}

export default __webpack_public_path__ + "b02749b9835816bde09da08477f37914.svg";
export { SvgIconHandouts as ReactComponent };